import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { showSnackBar } from "../../utils/commonServices";
import {  assignOrganisationProjectMemberApi, getBrandboxAssetsApi, getOrganisationProjectsApi, getProjectDetailsApi, removeOrganisationProjectMemberApi, updateOrganisationMemberRoleApi, updateOrganisationProjectMemberRoleApi, viewOrganisationProjectMembersApi } from "../../services/api";
import { setTheme } from "../../redux/customThemeSlice";
import { getTheme } from "../whitelabel/actions";
import { updateProjectState } from "../../redux/projectSlice";
import { setSnackbar } from "../../redux/messageSlice";
import { updateState } from "../../redux/commonSlice";
import { setAssetState } from "../../redux/assetSlice";


export default ()=> {
 
  const dispatch = useDispatch();
  const commonReducer = useSelector(state=> state.root.commonReducer)
  const projectReducer = useSelector(state=> state.projectReducer)
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const code = query.get('c')
 
////////////////////GET get organisation projects api  api/v1/events?organisation_id=3//////////////////////////

    const getOrganisationProjectsList = (payload, callback ) => {
      dispatch(updateProjectState({is_org_projects_loading: true, is_loading:true}))
      getOrganisationProjectsApi(payload) 
      .then((response) => {
      
        if(response?.data?.http_code === 200){
          dispatch(updateProjectState({org_projects_list: response.data.data.event_details}))
        //  console.log(response.data.data.event_details)
         dispatch(updateProjectState({is_org_projects_loading: false, is_loading:false}))
         callback && callback()
        
       }
      })
      .catch((error) => {
        dispatch(updateProjectState({is_org_projects_loading: false, is_loading:false}))
       if(error) {
        const errorObject = error?.response?.data;
        showSnackBar(dispatch, errorObject);
      }
      });
    }

    ////////////////////GET get projects members api api/v1/events/view_members?event_id=188//////////////////////////

    const getProjectMembersList = (payload, callback ) => {
      // console.log('payload----------', payload)
      // const values = {
      //   event_id: payload?.event_id
      // }
        dispatch(updateProjectState({is_loading: true}))
        viewOrganisationProjectMembersApi(payload) 
        .then((response) => {
         dispatch(updateProjectState({is_loading: false}))
          if(response?.data?.http_code === 200){
           dispatch(updateProjectState({org_project_members_list: response.data.data.user_details, all_project_members:response.data.data.user_details}))
           dispatch(updateState({selected_project_members:response.data.data.user_details}))
          //  console.log(response.data.data.user_details)
           callback && callback()
          
         }
        })
        .catch((error) => {
         if(error) {
          const errorObject = error?.response?.data;
          showSnackBar(dispatch, errorObject);
        }
        });
      }

  ////////////////////POST add projects member api api/v1/events/assign_member//////////////////////////

    const addProjectMembers = (values ,callback ) => {
        dispatch(updateProjectState({is_loading: true}))
          const payload = values   
      assignOrganisationProjectMemberApi(payload) 
        .then((response) => {
          // console.log({response})
          dispatch(updateProjectState({is_loading: false}))
          if(response?.data?.http_code === 200){
            getProjectMembersList({event_id: payload?.event_id})
            dispatch(setSnackbar({type:'success', flag:true, message: response?.data?.message}))
            !!callback && callback()
          }
        })
        .catch((error) => {
            if(error) {
                const errorObject = error?.response?.data;
                showSnackBar(dispatch, errorObject);
              }
        //   dispatch(setSnackbar({type:'error', flag:true, message: error.response.data.message}))
        });
      }


    ///////////////////////PUT update project member role api api/v1/events/update_role //////////////////////////

   const updateProjectMemberRole = (values ,callback, setSelectedRole, role ) => {
    dispatch(updateProjectState({is_loading:true}))  
    const payload = values
    updateOrganisationProjectMemberRoleApi(payload) 
    .then((response) => {
      // console.log({response})
      dispatch(updateProjectState({is_loading:false, invite_project_members_popup: true}))  
      if(response?.data?.http_code === 200){
        //   setSelectedRole(role?.name)
          getProjectMembersList({event_id: payload?.event_id})
          dispatch(setSnackbar({type:'success', flag:true, message: response?.data?.message}))
          !!callback && callback()
      }
    })
    .catch((error) => {
      dispatch(updateProjectState({is_loading:false, invite_project_members_popup: true}))  
      if(error) {
        const errorObject = error?.response?.data;
        showSnackBar(dispatch, errorObject);
      }
    //   dispatch(setSnackbar({type:'error', flag:true, message: error?.response?.data?.message}))
    });
  }
  

//////////////////////////DELETE remove project member api api/v1/events/remove_member ////////////////////////////

 const removeProjectMember = (values ,callback) => {
    const payload = values
    dispatch(updateProjectState({is_loading:true, loading_state: 'loading'})) 
  removeOrganisationProjectMemberApi(payload) 
  .then((response) => {
    // console.log({response})
    dispatch(updateProjectState({is_loading:false, loading_state: 'success', })) 
    if(response?.data?.http_code === 200){
      getProjectMembersList({event_id: payload?.event_id})
      dispatch(setSnackbar({type:'success', flag:true, message: response?.data?.message}))
      !!callback && callback()
    }
  })
  .catch((error) => {
    dispatch(updateProjectState({is_loading:false, loading_state: 'error', remove_user_confirmation_popup: false, invite_project_members_popup: true})) 
    if(error) {
        const errorObject = error?.response?.data;
        showSnackBar(dispatch, errorObject);
    }
    // dispatch(setSnackbar({type:'error', flag:true, message: error.response.data.message}))
  });
}


   ////////////////////GET get projects members api api/v1/events/view_members?event_id=188//////////////////////////

   const getProjectDetails = (payload, callback ) => {
    dispatch(updateProjectState({is_loading: true}))
    // dispatch(updateState({is_loading:true}))
    getProjectDetailsApi(payload) 
    .then((response) => {
      if(response?.data?.http_code === 200){
        //  dispatch(updateProjectState({org_project_members_list: response.data.data.user_details}))
        //  console.log(response.data.data, 'project details--------------')
        //  console.log('payload----------', payload)
        //  getProjectMembersList({event_id: payload?.id})
        dispatch(updateState({can_upload: response?.data?.data?.can_upload}))
        dispatch(updateProjectState({project_details: response?.data?.data}))
        dispatch(updateProjectState({is_loading: false}))
      // dispatch(updateState({is_loading:false}))
       callback && callback()
      
     }
    })
    .catch((error) => {
      dispatch(updateState({is_loading:false}))
     if(error) {
      const errorObject = error?.response?.data;
      showSnackBar(dispatch, errorObject);
    }
    });
  }


  
const getbrandboxAssets = (payload, callback ) => {
   dispatch(setAssetState({is_loading: true}))
   getBrandboxAssetsApi(payload)
    .then((response) => {
      dispatch(setAssetState({is_loading: false}))
      if(response?.data?.http_code === 200){
           console.log(response.data.data, 'response get assets ---------------------------')
           if(Array.isArray(response.data.data)){
             dispatch(setAssetState({ all_assets: response.data.data, }));
           }
      }else {
          dispatch(setSnackbar({type:'error', flag:true, message: 'some error occured'}))
      }
    })
    .catch((error) => {
      if(error) {
      dispatch(setAssetState({is_loading: false}))
      const errorObject = error?.response?.data;
      showSnackBar(dispatch, errorObject);
      }
    });
  }
     
    

  return {  getOrganisationProjectsList, getProjectMembersList, addProjectMembers, updateProjectMemberRole, removeProjectMember, getProjectDetails, getbrandboxAssets};
}